export default __webpack_public_path__ + "static/media/laproscopy.65c79fa4.svg";